import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import { withTranslation } from 'react-i18next';

class Contract extends Component {
    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <PageHelmet pageTitle={t('contract.pageTitle')} siteName={t('common.siteName')} />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                <div className="contract-page ptb--50 bg_color--5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="contract-hero text-center">
                                    <h1 className="contract-title">{t('contract.pageTitle')}</h1>
                                    <p className="contract-subtitle">{t('contract.addressValue')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="row contract-grid">
                            <div className="col-lg-5">
                                <div className="contract-card">
                                    <h3 className="contract-card-title">{t('contract.pageTitle')}</h3>

                                    <div className="contract-items">
                                        <div className="contract-item">
                                            <div className="contract-item-label">{t('contract.email')}</div>
                                            <div className="contract-item-value">
                                                <a href="mailto:pariwut.cha@chansawangfarm.com">pariwut.cha@chansawangfarm.com</a>
                                            </div>
                                        </div>

                                        <div className="contract-item">
                                            <div className="contract-item-label">{t('contract.website')}</div>
                                            <div className="contract-item-value">
                                                <a href="https://chansawangfarm.com" target="_blank" rel="noopener noreferrer">
                                                    chansawangfarm.com
                                                </a>
                                            </div>
                                        </div>

                                        <div className="contract-item">
                                            <div className="contract-item-label">{t('contract.facebook')}</div>
                                            <div className="contract-item-value">
                                                <a href="https://www.facebook.com/farmchansawangyasothon" target="_blank" rel="noopener noreferrer">
                                                    นาจันทร์สว่าง – Chansawang Farm & Camping Yasothon
                                                </a>
                                            </div>
                                        </div>

                                        <div className="contract-item">
                                            <div className="contract-item-label">{t('contract.instagram')}</div>
                                            <div className="contract-item-value">
                                                <a href="https://www.instagram.com/farmchansawangyasothon" target="_blank" rel="noopener noreferrer">
                                                    @farmchansawangyasothon
                                                </a>
                                            </div>
                                        </div>

                                        <div className="contract-item">
                                            <div className="contract-item-label">{t('contract.address')}</div>
                                            <div className="contract-item-value">{t('contract.addressValue')}</div>
                                        </div>

                                        <div className="contract-item">
                                            <div className="contract-item-label">{t('contract.hours')}</div>
                                            <div className="contract-item-value">{t('contract.hoursValue')}</div>
                                        </div>
                                    </div>

                                    <div className="contract-actions">
                                        <a className="rn-btn btn-default btn-border btn-opacity" href="mailto:pariwut.cha@chansawangfarm.com">
                                            {t('contract.email')}
                                        </a>
                                        <a
                                            className="rn-btn btn-default btn-border btn-opacity"
                                            href="https://www.google.com/maps?hl=th&gl=th&query=Chansawang%20Farm%20%26%20Camping%20Yasothon"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Google Maps
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7">
                                <div className="contract-card contract-map-card">
                                    <h3 className="contract-card-title">{t('contract.address')}</h3>
                                    <div className="contract-map">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4583.46709209255!2d104.1353856757809!3d15.818907246089287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3117cf58d94fa5c3%3A0xcb385d960ac65a8!2z4LiZ4Liy4LiI4Lix4LiZ4LiX4Lij4LmM4Liq4Lin4LmI4Liy4LiHIC0gQ2hhbnNhd2FuZyBGYXJtICYgQ2FtcGluZyBZYXNvdGhvbg!5e1!3m2!1sth!2sth!4v1751425884218!5m2!1sth!2sth"
                                            style={{ border: 0 }}
                                            title="Chansawang Map"
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            allowFullScreen=""
                                        ></iframe>
                                    </div>
                                    <div className="contract-hint">
                                        เลื่อนหน้าได้ตามปกติ — ถ้าจะซูมแผนที่ให้คลิกที่แผนที่ก่อน
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>

            </React.Fragment>
        )
    }
}
export default withTranslation()(Contract);
